import { render, staticRenderFns } from "./PanelAccountSettings.vue?vue&type=template&id=666a07f4&scoped=true&"
import script from "./PanelAccountSettings.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettings.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettings.vue?vue&type=style&index=0&id=666a07f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a07f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('666a07f4')) {
      api.createRecord('666a07f4', component.options)
    } else {
      api.reload('666a07f4', component.options)
    }
    module.hot.accept("./PanelAccountSettings.vue?vue&type=template&id=666a07f4&scoped=true&", function () {
      api.rerender('666a07f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelAccountSettings.vue"
export default component.exports